import { useEditorStore } from "@/lib/stores/editor-store/editor-store";
import { useEffect, useState } from "react";

const formatTime = (frame: number, fps: number): string => {
  const fullSeconds = Math.ceil(frame / fps);

  const minutes = Math.floor(fullSeconds / 60);
  const seconds = Math.floor(fullSeconds % 60);

  const minutesStr = String(minutes).padStart(1, "0");
  const secondsStr = String(seconds).padStart(2, "0");

  return `${minutesStr}:${secondsStr}`;
};

export default function VideoPreviewTime({
  durationInFrames,
  fps,
}: {
  durationInFrames: number;
  fps: number;
}) {
  const playerRef = useEditorStore((state) => state.service.getPlayerRef());
  const [currentFrame, setCurrentFrame] = useState(0);

  useEffect(() => {
    const player = playerRef?.current;

    if (!player) {
      return;
    }

    const onFrameUpdate = () => {
      setCurrentFrame(player.getCurrentFrame());
    };

    player.addEventListener("frameupdate", onFrameUpdate);

    return () => {
      player.removeEventListener("frameupdate", onFrameUpdate);
    };
  }, [playerRef]);

  return (
    <p className="text-xs text-text-secondary select-none">
      <span className="inline-block w-[26px]">
        {formatTime(currentFrame, fps)}
      </span>
      <span className="mx-[4px]">/</span>
      <span className="inline-block w-[26px]">
        {formatTime(durationInFrames, fps)}
      </span>
    </p>
  );
}
